export default __webpack_public_path__ + "static/media/logo.bc275fd2.svg";